export type ReportStatus =
  | 'pending'
  | 'clear'
  | 'complete'
  | 'consider'
  | 'suspended'
  | 'canceled'
  | 'closed'
  | 'dispute';

export type ReportDisplayStatus =
  | 'actionRequired'
  | 'inProgress'
  | 'complete'
  | 'consider'
  | 'suspended'
  | 'canceled'
  | 'disputed'
  | 'closed';

export enum ReportType {
  actionRequired = 'actionRequired',
}

export type Exception = Record<string, any>;

// A row of the BFF's `report.verifications`. `canceledAt` and
// `completionAllowed` are optional: the list endpoint does not send them
// today (see EVERI-5091).
export interface ReportVerification {
  id?: string;
  object?: string;
  exceptionType?: string;
  expiresAt?: string | null;
  completedAt?: string | null;
  canceledAt?: string | null;
  completionAllowed?: boolean;
}

export interface ReportSummary {
  id: string;
  candidateId?: string;
  accountName: string;
  accountId: string;
  type: string;
  status: ReportStatus;
  exceptions: Exception[];
  eta: string | null;
  lastTouchedAt: string;
  completeByDate: string | null;
  completedDate: string | null;
  reportOrder?: number;
  displayStatus: ReportDisplayStatus | null;
  expectedActionNeededByDate?: string;
  contactCompanyForReport?: boolean;
}
